<template>

    <!-- 保單借款 -->
    <Layout :header="{ text: '申請內容', backBtn: { visible: true }, closeBtn: { visible: false, to: {} }, }">

        <h2 class="pb-8 text-2xl font-bold">
            申請明細
        </h2>

        <div class="pb-6">
            <h3 class="pb-4 text-xl font-bold">
                匯款帳號
            </h3>
            <CaseBox :caseBox="accountInfo"></CaseBox>
        </div>

        <div>
            <h3 class="pb-4 text-xl font-bold">
                借款明細
            </h3>
            <CaseBox :caseBox="moneyInfo"></CaseBox>
            <CaseBox :caseBox="caseBox" :key="i" v-for="(caseBox, i) in caseItemList"></CaseBox>
        </div>

        <div class="text-center">
            <button class="py-3 text-[#EB4751] text-sm" @click="(e) => { infoBoxVisble = true }">取消預約申請</button>
        </div>

    </Layout>

    <InfoBox v-show="infoBoxVisble" :closeHandel="() => { infoBoxVisble = false; }" title="確定要取消預約申請嗎？" type="confirm"
             :okHandel="okHandel" :buttonText="{ no: '保留預約', yes: '取消預約' }" />

</template>

<script setup>
import '@/assets/cloudCounter/css/style.css';
import { ref } from 'vue';
import Layout from '@/components/cloudCounter/Layout.vue';
import CaseBox from '@/components/cloudCounter/CaseBox.vue';
import InfoBox from '@/components/cloudCounter/InfoBox.vue';
import { useRoute } from 'vue-router';

const route = useRoute();
console.log(route.query.id);

// #region 匯款帳號
const accountInfo = ref(null);

// 串接...
accountInfo.value = { key: '銀行帳號', value: '0120000 台北富邦商業銀行南京東路分行<br>00001234234567' };
// #endregion

// #region 借款明細
const moneyInfo = ref(null);
const caseItemList = ref(null);

// 串接...
moneyInfo.value = { key: '共欲借款總金額', value: '$100,000', flexClass: 'justify-between' };
caseItemList.value = [
    {
        boxList: [
            {
                title: 'XWO 富邦人壽富利旺終身壽險',
                subTitle: '1068302189-00',
                iconTitle: '',
                flexClass: '', // 空白則預設垂直排列，若要每列項目對齊左右兩側:justify-between
                list: [
                    { key: '本月利率（年利率）', value: '5.75%' },
                    { key: '借款幣別', value: '新臺幣' },
                    { key: '借款金額', value: '$66,000' }
                ]
            }
        ]
    },
    {
        boxList: [
            {
                title: 'XWO 富邦人壽富利旺終身壽險',
                subTitle: '1068302189-00',
                iconTitle: '申請優惠利率方案',
                flexClass: '', // 空白則預設垂直排列，若要每列項目對齊左右兩側:justify-between
                list: [
                    { key: '本月利率（年利率）', value: '5.75%' },
                    { key: '借款幣別', value: '新臺幣' },
                    { key: '借款金額', value: '$66,000' }
                ]
            }
        ]
    }
];
// #endregion

const infoBoxVisble = ref(false);
const okHandel = () => {

};

</script>

<style scoped>
</style>
